import { PermissionStatus } from 'expo-tracking-transparency';

import noop from 'utils/noop';

export const updateAmplitudeATTStatus = noop as (status: PermissionStatus) => void;
